<template>
  <v-main class="pa-0 mb-5">
    <v-row>
      <v-col cols="12" class="criticism-message__content mb-2 px-2">
        <p
          class="criticism-message__title-position font-weight-bold primary--text"
        >
          <span class="criticism-message__title-background px-1"
            ><v-icon color="primary" size="14"> {{ iconCard }} </v-icon>
            {{ nameCard }} em
            {{ formatHistoricDate(item.mensagens[0].data_criacao) }}
            {{ criticismStatus }}
          </span>
        </p>
        <v-row class="pb-5">
          <v-spacer />
          <v-col
            cols="12"
            sm="auto"
            v-if="showAllMessagesCriticism && showButtonRegularize"
            class="pr-sm-2 pb-5 pb-sm-0 d-flex justify-end"
          >
            <BaseButton
              class="secondary px-2"
              @click="$emit('regularize', item)"
              :disabled="disableRegularizeCriticism"
            >
              <v-icon color="white" size="14" class="pr-1">
                far fa-check-square
              </v-icon>
              REGULARIZAR
            </BaseButton>
          </v-col>
          <v-col
            cols="12"
            sm="auto"
            v-if="showAllMessagesCriticism"
            class="pr-sm-2 pb-5 pb-sm-0 d-flex justify-end"
          >
            <BaseButton
              class="secondary px-2"
              @click="$emit('answer', item)"
              :disabled="item.regularizada"
            >
              <v-icon color="white" size="14" class="pr-1">
                far fa-comment-dots
              </v-icon>
              RESPONDER
            </BaseButton>
          </v-col>
          <v-col cols="12" sm="auto" class="d-flex justify-end">
            <BaseButton icon @click="toggleCriticismMessages()">
              <v-icon color="primary" size="14"> {{ iconShow }} </v-icon>
            </BaseButton>
          </v-col>
        </v-row>
        <v-row v-if="showAllMessagesCriticism">
          <fragment v-for="(message, key) in item.mensagens" :key="key">
            <v-col
              cols="12"
              class="mb-2"
              v-if="message.orientacao.id == 'left'"
            >
              <v-row class="pa-5">
                <v-col cols="12">
                  <v-icon color="lightBlue" size="16">
                    fa-user
                  </v-icon>
                  <p
                    class="mb-0 darkBluishGray--text font-weight-bold d-inline-block pl-2"
                  >
                    {{ message.usuario.nome }} -
                    {{ formatHistoricDate(message.data_criacao) }}
                  </p>
                </v-col>
              </v-row>
              <v-row class="pa-5">
                <v-col cols="12">
                  <div
                    v-html="message.comentario"
                    class="mb-0 primary--text button"
                  />
                </v-col>
              </v-row>
              <v-row class="pa-5" v-if="hasDocuments(message)">
                <v-col cols="12">
                  <v-row>
                    <v-col
                      cols="auto"
                      v-for="(element, key) in message.documentos"
                      :key="key"
                      class="criticism-message__file px-4 py-2 mr-5 mb-5 mb-sm-0"
                    >
                      <div
                        class="d-flex align-center gray--text body-2"
                        @click="onPreviewFile(element)"
                      >
                        <v-icon class="pr-3" color="primary">
                          fa-file
                        </v-icon>
                        {{ element.arquivo.nome }}
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col v-else cols="12" class="mb-2">
              <v-row class="pa-5">
                <v-col cols="12" class="d-flex justify-end">
                  <p
                    class="mb-0 darkBluishGray--text font-weight-bold d-inline-block pr-2"
                  >
                    {{ formatHistoricDate(message.data_criacao) }} -
                    {{ message.usuario.nome }}
                  </p>
                  <v-icon color="lightBlue" size="16">
                    fa-user
                  </v-icon>
                </v-col>
              </v-row>
              <v-row class="pa-5">
                <v-col cols="12" class="d-flex justify-end">
                  <div
                    v-html="message.comentario"
                    class="mb-0 primary--text button"
                  />
                </v-col>
              </v-row>
              <v-row class="pa-5" v-if="hasDocuments(message)">
                <v-col cols="12">
                  <v-row class="d-flex justify-end">
                    <v-col
                      cols="auto"
                      v-for="(element, key) in message.documentos"
                      :key="key"
                      class="criticism-message__file px-4 py-2 ml-5 mb-5 mb-sm-0"
                    >
                      <div
                        class="d-flex align-center gray--text body-2"
                        @click="onPreviewFile(element)"
                      >
                        <v-icon class="pr-3" color="primary" size="22">
                          fa-file
                        </v-icon>
                        {{ element.arquivo.nome }}
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </fragment>
        </v-row>
      </v-col>
    </v-row>
  </v-main>
</template>
<script>
import { formatMessageDate, formatHistoricDate } from "@/utils/formats.js";
import DocumentsMixin from "@/mixins/DocumentsMixin";
export default {
  data: () => ({
    formatMessageDate,
    modal: false,
    itemsTypeCriticism: [
      {
        nome: "Chat Aberto",
        icon: "far fa-comment",
        status: ""
      },
      {
        nome: "Crítica Aberta",
        icon: "far fa-check-circle",
        status: " - REGULARIZADA"
      },
      {
        nome: "Crítica Aberta",
        icon: "fa-exclamation-circle",
        status: " - PENDENTE DE REGULARIZAÇÃO"
      }
    ],
    indexTypeCriticism: null,
    formatHistoricDate,
    showAllMessagesCriticism: false
  }),
  mixins: [DocumentsMixin],
  created() {
    this.updateStatusGroup();
    this.getIndexAccordingType();
  },
  computed: {
    showButtonRegularize() {
      return this.item.tipo.id == "critica";
    },
    nameCard() {
      return this.itemsTypeCriticism[this.indexTypeCriticism].nome;
    },
    iconCard() {
      return this.itemsTypeCriticism[this.indexTypeCriticism].icon;
    },
    criticismStatus() {
      return this.itemsTypeCriticism[this.indexTypeCriticism].status;
    },
    iconShow() {
      return this.showAllMessagesCriticism
        ? "fa-chevron-up"
        : "fa-chevron-down";
    },
    disableRegularizeCriticism() {
      return this.item.pode_regularizar
        ? this.item.regularizada
        : !this.item.pode_regularizar;
    }
  },
  methods: {
    getIndexAccordingType() {
      this.indexTypeCriticism =
        this.item.tipo.id == "mensagem" ? 0 : this.item.regularizada ? 1 : 2;
    },
    updateStatusGroup() {
      this.showAllMessagesCriticism = this.index == 0;
    },
    toggleCriticismMessages() {
      this.showAllMessagesCriticism = !this.showAllMessagesCriticism;
    },
    hasDocuments(item) {
      return item.documentos.length > 0;
    },
    showModal() {
      this.modal = true;
    }
  },
  props: {
    item: {
      type: Object
    },
    firstApprove: {
      type: Number
    },
    index: {
      type: Number
    }
  }
};
</script>
<style lang="sass">
.criticism-message__
  &content
    border: 1px solid #D5D5E0
    border-radius: 4px
  &title-position
    margin-top: -13px
    margin-left: 20px
    padding-left: 2px
  &title-background
    background-color: #FAFAFC
  &file
    border: 1px solid #D5D5E0
    border-radius: 4px
    background-color: #FAFAFC
    cursor: pointer
    height: 42px
  &approve
    font-size: 11px
    border: 1px solid #D5D5E0
    border-radius: 15px
    background-color: #FAFAFC
    top: 30px
    position: absolute
</style>
